<script setup lang="ts">
  import { useField } from 'vee-validate';
  import type { CheckboxProps } from '~/models/form-field';
  import { computed } from 'vue';

  const { name, checkedValue, rules, additionalClass, description } = defineProps<CheckboxProps>();

  const { errorMessage, handleChange, checked, meta } = useField(name, rules, {
    type: 'checkbox',
    checkedValue: checkedValue as any
  });

  const isRequired = computed(() => typeof rules === 'string' && rules.includes('required'));
</script>

<template>
  <div
    :class="[
      'form-checkbox',
      additionalClass,
      {
        'form-checkbox--error': !!errorMessage,
        'form-checkbox--success': meta.valid
      }
    ]">
    <p
      v-if="description && label"
      class="form-checkbox__title">
      {{ label }}
    </p>
    <label class="form-checkbox__wrapper">
      <span class="form-checkbox__input-wrapper">
        <input
          :id="name"
          type="checkbox"
          :name="name"
          :value="checkedValue"
          :checked="checked"
          class="form-checkbox__input"
          formnovalidate
          @input="handleChange(checkedValue)" />
        <span class="form-checkbox__icon" />
      </span>
      <span class="form-checkbox__label">
        <template v-if="description">
          {{ description }}
          <span v-if="isRequired">*</span>
        </template>
        <slot
          v-else
          :is-required="isRequired">
          {{ label }}
          <span v-if="isRequired">*</span>
        </slot>
      </span>
    </label>
    <div
      v-if="errorMessage"
      class="form-checkbox__error">
      <span />
      <span>{{ errorMessage }}</span>
    </div>
  </div>
</template>
